export const getCountPages = (totalPages, limit) => {
    return Math.ceil(totalPages / limit)
}